import { apiInstance } from './api';
import { ApiRoutes } from './consts';

export interface FeedbackData {
  description: string;
  tags: string[];
  mediaFiles?: File[];
}

export const submitFeedback = async (data: FeedbackData) => {
  const formData = new FormData();
  
  // Add description
  formData.append('description', data.description);
  
  // Add tags as JSON string
  formData.append('tags', JSON.stringify(data.tags));
  
  // Add media files if they exist
  if (data.mediaFiles && data.mediaFiles.length > 0) {
    data.mediaFiles.forEach((file) => {
      formData.append('mediaFiles', file);
    });
  }
  
  return apiInstance.post(`${ApiRoutes.Business}/feedback`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
